<template>
    <ul>
        <li> <router-link to="/help/read/search">本を探す</router-link> </li>
        <li> <router-link to="/help/read/use-case">展示棚</router-link> </li>
        <li> <router-link to="/help/read/ratings">レーティング</router-link> </li>
        <li> <router-link to="/help/read/layout">小説レイアウトの変更</router-link> </li>
        <li> <router-link to="/help/read/follow">フォローとお気に入り</router-link> </li>
        <li> <router-link to="/help/read/review">拍手する・感想を送る</router-link> </li>
        <li> <router-link to="/help/read/epub">電子書籍</router-link> </li>
    </ul>
</template>